import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto px-5">
        <div className="flex flex-col">
          <h3 className="mb-4 text-xl">TravelMaker</h3>
          <p>Your personal travel companion that makes exploring new cities easy and enjoyable.</p>
          <p className="mt-3 text-sm opacity-75">Developed by Kolpo LTD</p>
          
        </div>

        <div className="flex flex-col">
          <h3 className="mb-4 text-xl">Links</h3>
          <Link to="/" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Home
          </Link>
          <Link to="/trips" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Trips
          </Link>
          <Link to="/about" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            About Us
          </Link>
          <Link to="/contact" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Contact Us
          </Link>
          <Link to="/blog" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Blog
          </Link>
          <Link to="/partners" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Partners
          </Link>
        </div>

        <div className="flex flex-col">
          <h3 className="mb-4 text-xl">Legal</h3>
          <Link to="/privacy" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Privacy Policy
          </Link>
          <Link to="/terms" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Terms & Conditions
          </Link>
        </div>

        <div className="flex flex-col">
          <h3 className="mb-4 text-xl">Download</h3>
          <a
            href="https://apps.apple.com/app/travelmaker-ai/id6742571605"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300"
          >
            App Store
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.comrades.travelmaker"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300"
          >
            Google Play
          </a>
          <div className="flex space-x-4 mt-4">
            <a href="https://www.tiktok.com/@travelmaker.app/" target="_blank" rel="noopener noreferrer" className="text-white transition-colors duration-300">
              <img src="/images/tiktok.png" alt="TikTok" className="h-8 w-8" />
            </a>
            <a href="https://www.facebook.com/travelmakerapp/" target="_blank" rel="noopener noreferrer" className="text-white transition-colors duration-300">
              <img src="/images/facebook.png" alt="Facebook" className="h-8 w-8" />
            </a>
            <a href="https://www.instagram.com/travelmaker.app/" target="_blank" rel="noopener noreferrer" className="text-white transition-colors duration-300">
              <img src="/images/instagram.png" alt="Instagram" className="h-8 w-8" />
            </a>
          </div>
        </div>
      </div>

      <div className="text-center mt-8 pt-4 border-t border-white border-opacity-10 opacity-60 max-w-6xl mx-auto">
        <p>&copy; {new Date().getFullYear()} TravelMaker by Kolpo LTD. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
